import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { semItensVazios } from "../utils/chartMinBar";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const formatK = (value) => {
  if (value == null || value < 1) return "";
  const n = Number(value);
  if (Number.isNaN(n)) return String(value);
  if (n >= 1_000_000) return `${parseFloat((n / 1_000_000).toFixed(2))}m`;
  if (n >= 1_000) return `${parseFloat((n / 1_000).toFixed(2))}k`;
  return parseFloat(n.toFixed(2)).toString();
};

const options = {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  layout: { padding: { right: 40 } },
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: (ctx) => ` ${formatK(ctx.raw)}`,
      },
    },
    datalabels: {
      anchor: "end",
      align: "end",
      color: "#01054C",
      font: { size: 11, weight: "bold" },
      formatter: (value) => formatK(value),
      offset: 4,
    },
  },
  scales: {
    x: {
      display: false,
      grid: { display: false },
      beginAtZero: true,
    },
    y: {
      grid: { display: false },
      border: { display: false },
      ticks: {
        font: { size: 9, lineHeight: 1.1 },
        color: "#364153",
        maxRotation: 0,
        crossAlign: "far",
      },
    },
  },
};

const TopMetasNegociadas = ({ labels = [], data = [] }) => {
  const chartData = useMemo(() => {
    const { labels: itens, series } = semItensVazios(labels, [data]);

    return {
      labels: itens,
      datasets: [
        {
          label: "Meta (t)",
          data: series[0],
          backgroundColor: "#003DA5",
          borderRadius: 3,
          barPercentage: 0.75,
          categoryPercentage: 0.85,
        },
      ],
    };
  }, [labels, data]);

  return (
    <div className="bg-white rounded-lg p-6 flex-1 min-w-0" style={{ boxShadow: "0 1px 6px 0 rgba(0,0,0,0.10)" }}>
      <h2 className="text-[20px] font-bold mb-2" style={{ color: "#01054C" }}>TOP 5 – Metas Negociadas</h2>
      <div style={{ height: 240 }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default TopMetasNegociadas;
